import React from "react";
import { arrayOf, shape, string } from "prop-types";

const propTypes = {
  values: arrayOf(
    shape({
      text: string,
      href: string,
      title: string,
    }),
  ),
};

const Taxonomy = (props) => {
  const { values } = props;

  if (!values || values.length < 1) {
    return null;
  }

  return (
    <div className="taxonomy">
      {values.map((value, ind) => (
        <a
          key={`${value.href}-${ind}`}
          className="taxonomy__link link"
          href={value.href}
          aria-label={value.title}
        >
          {value.text}
        </a>
      ))}
    </div>
  );
};
Taxonomy.propTypes = propTypes;
export default Taxonomy;
